///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { createSlice } from "@reduxjs/toolkit";
import _groupBy from "lodash/groupBy";
import _orderBy from "lodash/orderBy";

import { getCoveredRoutesWithMultiFilters } from "../api/api";
import { mapLegAlerts } from "../helpers/alertHelpers";

export const initialState = {
  isFetching: false,
  coveredRoutes: [],
  totalCount: 0,
};

const mapRouteLegAlerts = (routeLegs) => {
  const groupedRouteLegs = _groupBy(routeLegs, "id");

  for (let id in groupedRouteLegs) {
    const sortedRouteLegs = _orderBy(groupedRouteLegs[id], "currentLeg");

    mapLegAlerts(sortedRouteLegs);
  }
};

const coveredRoutesSlice = createSlice({
  name: "coveredRoutes",
  initialState,
  reducers: {
    requestCoveredRoutes: (state) => {
      state.isFetching = true;
    },
    receiveCoveredRoutesSuccess: (state, { payload }) => {
      mapRouteLegAlerts(payload.results);
      state.coveredRoutes = payload.results;
      state.totalCount = payload.pagingParams.totalRecords;
      state.isFetching = false;
    },
    receiveCoveredRoutesFailure: (state) => {
      state.isFetching = false;
    },
    updateRoute: (state, { payload }) => {
      const { routeId, currentLeg, updates } = payload;
      const routeToUpdate = state.coveredRoutes.find(
        (route) => route.id === routeId && route.currentLeg === currentLeg
      );

      Object.assign(routeToUpdate, updates);
    },
  },
});

export const {
  requestCoveredRoutes,
  receiveCoveredRoutesSuccess,
  receiveCoveredRoutesFailure,
  updateRoute,
} = coveredRoutesSlice.actions;

export const coveredRoutesReducer = coveredRoutesSlice.reducer;

const GOTRACK_LIMIT = window.env.GOTRACK_LIMIT;

export const fetchCoveredRoutes = (updatedFilters) => async (
  dispatch,
  getState
) => {
  let coveredRoutes;
  const state = getState();
  dispatch(requestCoveredRoutes());

  const { currentPage } = updatedFilters;

  try {
    const params = {
      ...updatedFilters,
      currentPage: currentPage,
      limit: GOTRACK_LIMIT,
      offset: currentPage * GOTRACK_LIMIT,
    };
    coveredRoutes = await getCoveredRoutesWithMultiFilters(params);
  }
  catch (e) {
    dispatch(receiveCoveredRoutesFailure());
    return;
  }
  dispatch(receiveCoveredRoutesSuccess(coveredRoutes));
};
